import { Typography } from "@fullscript/aviary-web";

import * as dimensions from "@styles/emotion-styles/dimensions";

import * as styles from "./PromoSlide.styles";

const BANNER_SIZES = `(min-width: ${dimensions.widescreen}) ${styles.contentMaxWidthWidescreen}, ${styles.contentMaxWidth}`;

interface Props {
  backgroundColor: string;
  bannerImageUrl: string;
  bannerImage2xUrl: string;
  headline: string;
  subtext: string;
}

const PromoSlide = ({
  backgroundColor,
  bannerImageUrl,
  bannerImage2xUrl,
  headline,
  subtext,
}: Props) => (
  <div css={theme => styles.slide(theme, backgroundColor)}>
    <div css={styles.content}>
      <img
        src={bannerImageUrl}
        srcSet={`${bannerImageUrl} 415w, ${bannerImage2xUrl} 830w`}
        sizes={BANNER_SIZES}
        alt=""
        css={styles.banner}
        draggable={false}
      />
      <div css={styles.textStack}>
        <Typography variant="h3" intention="inverse" isMarginless>
          {headline}
        </Typography>
        <Typography variant="footnote" intention="inverse" isMarginless>
          {subtext}
        </Typography>
      </div>
    </div>
  </div>
);

export { PromoSlide };
